import React from 'react';
import { AwardIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { profile } from '../data/profile';
import { competencies } from '../data/expertise';
export function ExecutiveProfile() {
  return <section id="profile" className="scroll-mt-16 bg-white" data-id="element-90" data-mp="3gea3l4r50n9x">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-91" data-mp="3ldd88o37grhd">
        <SectionHeading index="I" title="Executive Profile & Governance Overview" data-id="element-92" data-mp="3lfpmaq5uehp5" />

        <div className="mt-14 grid gap-14 lg:grid-cols-[1.35fr_1fr] lg:gap-20" data-id="element-93" data-mp="3ccyb8rgvpny1">
          <div className="space-y-6" data-id="element-94" data-mp="3cf1c66jkl1hj">
            {profile.narrative.map((paragraph, i) => <p key={paragraph.slice(0, 24)} className={i === 0 ? 'font-serif text-xl leading-relaxed text-navy' : 'text-base leading-relaxed text-steel-400'} data-id="element-95" data-mp="2xmh915wf6u03" data-mpi={i}>
                {paragraph}
              </p>)}
          </div>

          <aside className="bg-canvas p-8 lg:p-10" data-id="element-96" data-mp="1fiu09eb6ef1b">
            <div className="flex items-center gap-3" data-id="element-97" data-mp="1al29inm9oyyp">
              <AwardIcon className="h-5 w-5 text-bronze-600" aria-hidden="true" data-id="element-98" data-mp="1akiqf3kvs4j3" />
              <h3 className="text-[11px] font-semibold uppercase tracking-overline text-navy" data-id="element-99" data-mp="1ph9tpnxoe0dz">
                Distinctions
              </h3>
            </div>
            <ul className="mt-7 space-y-6" data-id="element-100" data-mp="wtnfzmuqhfde">
              {profile.awards.map(award => <li key={award.title} className="border-l-2 border-bronze pl-4" data-id="element-101" data-mp="rukkou4k2nim">
                  <p className="font-serif text-lg leading-snug text-navy" data-id="element-102" data-mp="rsg7tmooie67">
                    {award.title}
                  </p>
                  <p className="mt-1 text-sm text-steel-400" data-id="element-103" data-mp="11t092pc77iof">{award.issuer}</p>
                </li>)}
            </ul>
          </aside>
        </div>

        <div className="mt-20" data-id="element-104" data-mp="e11m383dzyvg">
          <h3 className="text-[11px] font-semibold uppercase tracking-overline text-bronze-600" data-id="element-105" data-mp="94b5mjno719i">
            Core Leadership Competencies
          </h3>
          <ul className="mt-8 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-106" data-mp="yrp0309u82b9">
            {competencies.map((competency, i) => <li key={competency.title} className="flex flex-col border-t border-steel-200 pt-6" data-id="element-107" data-mp="17kiobn79ic19" data-mpi={i}>
                <span className="font-serif text-sm text-bronze-600" data-id="element-108" data-mp="1ciaeabocjo2t">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h4 className="mt-3 font-serif text-xl leading-snug text-navy" data-id="element-109" data-mp="juy1gt7zmump">
                  {competency.title}
                </h4>
                <p className="mt-3 text-sm leading-relaxed text-steel-400" data-id="element-110" data-mp="oszjdatognwl">
                  {competency.description}
                </p>
                <div className="mt-auto flex flex-wrap gap-2 pt-5" data-id="element-111" data-mp="tr10vrbggf5y">
                  {competency.tags.map(tag => <span key={tag} className="whitespace-nowrap bg-canvas px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-navy-700" data-id="element-112" data-mp="258ajycqo956q">
                      {tag}
                    </span>)}
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}